import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import styles from './SpotDescriptor.module.scss';

interface Props {
  percentage: number;
}

const LinearScale: React.FC<Props> = ({ percentage }) => {
  const inlineStyles = useMemo(
    () => ({
      background: `linear-gradient(
      to right,
      #8CBCFF ${percentage}%,
      #E4E7ED 0
    )`,
    }),
    [percentage],
  );
  return (
    <Box
      className={styles.scaleBar}
      style={inlineStyles}
      data-testid="spot-descriptor-linear-scale"
    />
  );
};

export default LinearScale;
